module.exports = __webpack_public_path__ + "static/media/the_lost_tribe_bg.00e9687b.jpeg";